export default __webpack_public_path__ + "static/media/ic_inbox_1.014c7f7b.svg";